import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import { SEARCH_TEMPLATES_SUCCESS, SEARCH_TEMPLATES_REQUEST, SEARCH_TEMPLATES_FAILURE } from "../actions/template.actions";

export type TemplateState = {
    templates: DTOS.Template[];
    templatesLoading: boolean;
}

const initialState: TemplateState = {
    templates: undefined,
    templatesLoading: false,
};

export default function template(state: TemplateState = initialState, action) {
    switch (action.type) {
        case SEARCH_TEMPLATES_REQUEST:
            return updateTemplatesLoading(state, true);
        case SEARCH_TEMPLATES_SUCCESS:
            return updateTemplates(state, action);
        case SEARCH_TEMPLATES_FAILURE:
            return updateTemplatesLoading(state, false);
    }
    return state;

}

function updateTemplates(state: TemplateState, action) {
    const newState = update(state, {
        templates: { $set: action.templates }
    });

    return updateTemplatesLoading(newState, false);
}

function updateTemplatesLoading(state: TemplateState, loading) {
    return update(state, {
        templatesLoading: { $set: loading }
    })
}
